// Add authentication token to every request
export const authInterceptor = config => {
  const token =
    localStorage.getItem('msalAccessToken') ||
    'eyJraWQiOiJuMHlkWHVTbTdfLVVRYmdwaG5pYWFrbDN3MUFVbE5uV0VtcGtkam93NW9RIiwiYWxnIjoiUlMyNTYifQ.eyJ2ZXIiOjEsImp0aSI6IkFULlVGVFlwVzFXQm5EczktbDAwQS1rVW9JclY0dDhManRHczhQM3dwQnRoanciLCJpc3MiOiJodHRwczovL3BlcHNpY28ub2t0YXByZXZpZXcuY29tL29hdXRoMi9kZWZhdWx0IiwiYXVkIjoiYXBpOi8vZGVmYXVsdCIsImlhdCI6MTczODMxNjE1MywiZXhwIjoxNzM4MzE5NzUzLCJjaWQiOiIwb2EyMWlndGNjblFueFJyNTBoOCIsInNjcCI6WyJteUN1c3RvbSJdLCJzdWIiOiIwb2EyMWlndGNjblFueFJyNTBoOCIsImVtYWlsIjoiIn0.AFpexBCNCWbeIVqSuCqsBlDA7F-Y2lpSEjZ1NBQKP5k53z8VzwoSAUYDWCmv1p4hmfAT3GK8al37sLNbW0_dE2cl2EGhaGq4a1__XsS0Izq7OYKcpTyqadGNkHA-NKPyTEZxsPAbBU-r3vFxEbdfndjsKTcyWdMx3XybGAIZ40k2egCA7oojEizdDt4ROom4bMhJJ05g7zob5tu6AJpa7O_NaV2Aq_CFLagM7txedX5FRn8H3k628yOoeObcUWC6DivEYEMhxuArpaldHCyeWGqvAF04G6T-Gzvxl4W8HZh0jed1gu8niSaPxr0vfJj8QwqEt5Ds1ptRu0s13UCmeA' // Retrieve token from localStorage or other storage
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

// Attach the interceptor to an Axios instance
export const attachAuthInterceptor = axiosInstance => {
  axiosInstance.interceptors.request.use(authInterceptor, error => Promise.reject(new Error(error)))
}
